export class UpdateIntegrationConfigurationDto {

    integrationConfig?: Record<string, string>;
}
